import {
  Greyscale,
  SecondaryColor,
  Typography,
  WarningSolidIcon,
} from 'glints-aries';
import styled from 'styled-components';

import { ReadMore } from 'src/components/ReadMore/ReadMore';

export const AlertTitle = styled(Typography.Paragraph)`
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;

export const MessageCount = styled(Typography.Paragraph).attrs({
  variant: 'caption',
  color: Greyscale.grey,
})`
  margin-top: 8px;
`;

export const ReadMoreInfo = styled(ReadMore)`
  margin-top: 8px;

  div:first-child > div:nth-child(2) {
    margin-top: 8px;
  }
`;

export const AlertDescription = styled(Typography.Paragraph).attrs({
  variant: 'caption',
})``;

export const WarningIcon = styled(WarningSolidIcon)`
  min-width: 15px;
  margin-top: 2px; // to align icon with text
  margin-right: 10px;
  fill: ${SecondaryColor.orange};
`;
